export enum OccupiedAssetsAction {
    EXCLUDE_BOOKING_DATES = 'excludeBookingDates',
    ALL_OCCUPIED_DATES = 'allOccupiedDates',
}
